var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEyeIcon = function SvgEyeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "9.0-Minc-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9.8.5-Minc-Admin-/-Ecommerce-management----user-actions-after-inactive",
    transform: "translate(-1204, -284)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/09.Web/07.View-action/3-row/Right",
    transform: "translate(1186, 249.8571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(16, 30.1429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.98893229,4.79166664 C11.4973958,4.79166664 13.0273438,5.26529946 14.413086,6.16113279 C15.6656901,6.97005207 16.7832032,8.10156249 17.6445313,9.43359375 C17.8665857,9.77773628 17.8678571,10.2196897 17.6477865,10.5651042 C16.7897136,11.9082031 15.6744792,13.0439453 14.4225261,13.8502604 C13.0426432,14.7386068 11.5094401,15.2083334 9.98893229,15.2083334 C8.43424478,15.2083334 6.94010415,14.7526042 5.55175779,13.8531901 C4.31868487,13.0553386 3.21223955,11.9222005 2.35253902,10.5768229 C2.12425914,10.2226391 2.13248842,9.76565704 2.37337236,9.41992187 C3.41666663,7.92415364 4.61783851,6.76236978 5.94368488,5.96712238 C7.24381509,5.18717446 8.6048177,4.79166664 9.98893229,4.79166664 Z M10,6.87499998 C8.27411015,6.87499998 6.87499998,8.27411015 6.87499998,10 C6.87499998,11.7258899 8.27411015,13.125 10,13.125 C11.7250718,13.1230268 13.1230268,11.7250718 13.125,10 C13.125,8.27411015 11.7258899,6.87499998 10,6.87499998 Z M10,7.91666666 C11.1505932,7.91666666 12.0833333,8.84940677 12.0833333,10 C12.0833333,11.1505932 11.1505932,12.0833333 10,12.0833333 C8.84940677,12.0833333 7.91666666,11.1505932 7.91666666,10 C7.91666666,8.84940677 8.84940677,7.91666666 10,7.91666666 Z",
    id: "Combined-Shape"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye-icon.f84ee55c.svg";
export { ForwardRef as ReactComponent };